<template>
    <div v-if="this.currentRange" class="card help-banner" role="note" aria-live="polite">
        <p class="help-banner__text" v-html="text"></p>
    </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import IRange from '@/models/vehicle/interfaces/range.d';

const VehicleModule = namespace('vehicleModule');

@Component
export default class HelpBannerComponent extends Vue {
    @VehicleModule.Getter public currentRange!: IRange;

    @Prop({
        default:
            '<strong>Unsure which to pick?</strong> No pressure! Just select “Not sure” to keep going.'
    })
    public text!: string;
}
</script>
